import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl'
import { get } from 'lodash'
import { compose } from 'recompose'

import { ConfigurationFile } from 'containers/misc'
import { Checkbox, Select, Input, InputPhone } from 'components/fields'
import { ReadAllArea, Button } from 'components/misc'
import { Form, Description } from 'components/layout'
import { form } from 'helpers/decorators'
import { validate } from 'models/parental-consent'
import { CONFIGURATION_KEYS, PAYMENTS } from 'constants/enums'
import {
  apiConfiguration
} from 'helpers/decorators/api'

const enhance = compose(
  injectIntl,
  form({
    form: 'parentalConsentForm',
    disableHook: true,
    validate
  }),
  apiConfiguration()
)

class ParentalContestForm extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    codeLists: PropTypes.object.isRequired,
    values: PropTypes.object,
    alreadySubmitted: PropTypes.bool.isRequired,
    intl: PropTypes.object.isRequired,
    configuration: PropTypes.object.isRequired,
    onGetConfigurationValue: PropTypes.object.isRequired
  }

  static defaultProps = {
    data: {}
  }

  componentDidMount = () => {
    if (get(this.props, 'data.organizationId', null)) {
      this.props.onGetConfigurationValue(CONFIGURATION_KEYS.parentalConsentSurveyDoc.id, this.props.data.organizationId)
      this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isParentalConsentRequirementsEnabled.id, this.props.data.organizationId)
      this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isParentalConsentRequirementsEnabled2.id, this.props.data.organizationId)
      this.props.onGetConfigurationValue(CONFIGURATION_KEYS.parentalConsentRequirementsTitle.id, this.props.data.organizationId)
      this.props.onGetConfigurationValue(CONFIGURATION_KEYS.parentalConsentRequirements.id, this.props.data.organizationId)
      this.props.onGetConfigurationValue(CONFIGURATION_KEYS.parentalConsentRequirementsTitle2.id, this.props.data.organizationId)
      this.props.onGetConfigurationValue(CONFIGURATION_KEYS.parentalConsentRequirements2.id, this.props.data.organizationId)
    }
  }

  render () {
    const {
      handleSubmit,
      codeLists,
      onSubmit,
      values,
      loading,
      data,
      alreadySubmitted,
      intl,
      configuration
    } = this.props
    const defaultMessage =
      'This form <strong>must</strong> be completed for applicants under <strong> 18 years of age/the national age of legal responsibility in the country in which you live </strong> by his/her parent/guardian.'

    const parentalConsentSurveyUrl = get(
      configuration,
      `valuesByOrganizationId[${data.organizationId}][${CONFIGURATION_KEYS.parentalConsentSurveyDoc.id}].fileUrl`
    )

    const isParentalConsentRequirementsEnabled = get(configuration,`valuesByOrganizationId[${data.organizationId}][${CONFIGURATION_KEYS.isParentalConsentRequirementsEnabled.id}].booleanValue`)
    const isParentalConsentRequirementsEnabled2 = get(configuration,`valuesByOrganizationId[${data.organizationId}][${CONFIGURATION_KEYS.isParentalConsentRequirementsEnabled2.id}].booleanValue`)

    const customParentalConsentReqEnabled = isParentalConsentRequirementsEnabled || isParentalConsentRequirementsEnabled2

    const parentalConsentRequirementsTitle = get(configuration,`valuesByOrganizationId[${data.organizationId}][${CONFIGURATION_KEYS.parentalConsentRequirementsTitle.id}].translatedText`)
    const parentalConsentRequirements = get(configuration,`valuesByOrganizationId[${data.organizationId}][${CONFIGURATION_KEYS.parentalConsentRequirements.id}].translatedText`)
    const parentalConsentRequirementsTitle2 = get(configuration,`valuesByOrganizationId[${data.organizationId}][${CONFIGURATION_KEYS.parentalConsentRequirementsTitle2.id}].translatedText`)
    const parentalConsentRequirements2 = get(configuration,`valuesByOrganizationId[${data.organizationId}][${CONFIGURATION_KEYS.parentalConsentRequirements2.id}].translatedText`)

    const isAccepted = (!isParentalConsentRequirementsEnabled && !isParentalConsentRequirementsEnabled2 && get(values, 'accepted')) ||
    (isParentalConsentRequirementsEnabled && get(values, 'customParentalConsent') && !isParentalConsentRequirementsEnabled2) ||
      (isParentalConsentRequirementsEnabled && get(values, 'customParentalConsent') && isParentalConsentRequirementsEnabled2 && get(values, 'customParentalConsent2'))

    return (
      <Form
        onSubmit={handleSubmit(fields =>
          onSubmit(fields, get(data, 'awardPayment.originPaymentType.value'))
        )}
        className="content"
        loading={loading}
      >
        <h1 className="alpha">
          <FormattedMessage
            id="moduleTitle.parent_consent_form"
            defaultMessage="Parent/guardian consent form"
          />
        </h1>

        {alreadySubmitted &&
        <div>
          <h2 className="omega">
            <FormattedMessage
              id="parentalConsent.form_has_been_sent"
              defaultMessage="Form has been already sent"
            />
          </h2>
        </div>}

        {!alreadySubmitted &&
        <div>
          <Description style={{ margin: '0 0 45px 0' }}>
            <FormattedHTMLMessage
              id="parentalConsent.this_form_must_be_completed"
              defaultMessage={defaultMessage}
            />
          </Description>

          <h2 className="omega">
            <FormattedMessage
              id="moduleTitle.your_personal_information"
              defaultMessage="Your personal information"
            />
          </h2>

          <div className="row">
            <div className="col-xs-12 col-md-3">
              <Select
                label="Title"
                name="title"
                options={get(codeLists, 'titles.list')}
                intlKey="label.title"
              />
            </div>

            <div className="col-xs-12 col-md-3">
              <Input
                label="First Name"
                name="firstName"
                intlKey="label.first_name"
              />
            </div>

            <div className="col-xs-12 col-md-3">
              <Input
                label="Last Name"
                name="lastName"
                intlKey="label.last_name"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-md-3">
              <Input
                label="E-mail"
                name="email"
                type="email"
                intlKey="label.email"
              />
            </div>

            <div className="col-xs-12 col-md-3">
              <InputPhone
                label="Phone"
                name="phoneNumber"
                intlKey="label.phone"
              />
            </div>

            <div className="col-xs-12 col-md-3">
              <Input
                label="Relationship to participant"
                name="relationship"
                intlKey="label.relationship_to_participant"
              />
            </div>
          </div>

          <h2 className="omega">
            <FormattedMessage
              id="moduleTitle.your_home_address"
              defaultMessage="Your home address"
            />
          </h2>

          <div className="row">
            <div className="col-xs-12 col-md-6">
              <Input
                label="Address First Line"
                name="addressLine1"
                intlKey="label.addressLine1"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-md-6">
              <Input
                label="Address Second Line"
                name="addressLine2"
                intlKey="label.addressLine2"
                optional
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-md-3">
              <Input label="City" name="addressCity" intlKey="label.city" />
            </div>

            <div className="col-xs-12 col-md-3">
              <Input
                label="State/Province/Region"
                name="addressStateOrProvince"
                intlKey="label.state_province"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-md-3">
              <Input
                label="Post code"
                name="addressZipCode"
                intlKey="label.post_code"
              />
            </div>
          </div>

          {! customParentalConsentReqEnabled && <div>
         <h2 className="omega">
            <FormattedMessage
              id="moduleTitle.requirements_and_conditions"
              defaultMessage="Requirements and conditions"
            />
          </h2>

          <ReadAllArea>
            <p>
              <FormattedMessage
                id="parentalConsent.i_understand_that_the_participant"
                defaultMessage="1. I  understand  that  the  participant  cannot  participate  in  the  Award  until  this form  has  been  completed (including  parent/guardian  consent)  and  returned  to  the  relevant  Award  Operator  with  the  applicable registration fee, and has then been accepted by the Award Unit."
              />
            </p>
            <p>
              <FormattedMessage
                id="parentalConsent.i_consent_to_the_award_unit"
                defaultMessage="2. I consent to the Award Unit and any other individuals, including volunteers*, who are involved in or assist in  organising  the  Award,  and  hired  transportation  drivers,  transporting  the  participant  for  the  purpose  of participating in activities or functions related to the Award, as required. I understand that the Award Unit will notify me in advance of when and where such travel will occur."
              />
            </p>
            <p>
              <FormattedMessage
                id="parentalConsent.i_as_the_parent"
                defaultMessage="3. I, as the parent/guardian, accept responsibility for any risks that may arise in Award activities."
              />
            </p>
            <p>
              <FormattedMessage
                id="parentalConsent.i_authorise_employees"
                defaultMessage="4. I authorise employees, officers or agents of the Award Unit and any other individuals who participate in, are involved in or assist in organising the Award, in the event of any accident, injury, illness or loss suffered by the  participant  whilst  participating  in,  or  travelling  to  and  from,  any  activities  or  functions  related  to  the Award,  to  obtain  any  necessary  medical  assistance  or treatment  including,  but  not  limited  to,  engaging  any doctors, nurses or hospital accommodation."
              />
            </p>
            <p>
              <FormattedMessage
                id="parentalConsent.i_consent_to_pay_all"
                defaultMessage="5. I consent to pay all such doctors, nurses or hospital accommodation fees and expenses incurred on behalf of the participant as a result of any such accident, injury, illness or loss suffered by the participant whilst participating in, or travelling to and from, any activities or functions related to the Award."
              />
            </p>
            <p>
              <FormattedMessage
                id="parentalConsent.i_consent_to_and_understand_that"
                defaultMessage="6. I consent to and understand that photographs may be taken of the participant participating in certain activities related to the Award and such photographs may be used for promotional purposes provided an appropriate release form has been signed by both the participant and their parent/guardian."
              />
            </p>
            <p>
              <FormattedMessage
                id="parentalConsent.i_have_read_and_understand"
                defaultMessage="7. I have read and understood the different levels and requirements of the Award as set out in the Outline of the Award (page 5 of this form)."
              />
            </p>
            <p>
              <FormattedMessage
                id="parentalConsent.i_understand_every_participant_must"
                defaultMessage="8. I understand every participant must participate in the Award through an Award Unit who has the discretion to accept or reject participants and proposed activities to be undertaken as part of the Award."
              />
            </p>
            <p>
              <FormattedMessage
                id="parentalConsent.i_understand_that_the_participant_cannot"
                defaultMessage="9. I understand that the participant cannot commence any particular section of the Award until I have satisfied myself that any volunteer nominated by the participant, who is not an employee of the Award Unit, is suitably experienced and/or qualified to instruct/supervise/assess that section of the Award; and until any relevant volunteers have completed and returned required documentation to the Award Unit."
              />
            </p>
            <p>
              <FormattedMessage
                id="parentalConsent.i_understand_that_upon_acceptance_into"
                defaultMessage="10. I understand that upon acceptance into the Award by the Award Unit, the participant will receive a Record Book or gain access to the Online Record Book (ORB). The participant will read the requirements of the Award contained in the Record Book or ORB prior to starting activities in relation to the Award. I understand that the Award Unit has the discretion to determine whether the Award requirements have been met and therefore whether a Bronze, Silver or Gold Award should be issued. I understand that the Award Operator may provide participants with limited insurance in respect of personal accident and public liability insurance starting upon acceptance into the Award by the Award Unit, but that the responsibility for obtaining and maintaining personal accident cover lies with the participant/and their parent/guardian."
              />
            </p>
            <p>
              <FormattedHTMLMessage
                id="parentalConsent.i_understand_that_a_and_b"
                defaultMessage="11. I understand that: a. a participant must not drive a motor vehicle or transport other participants participating in activities related to the Award unless the participant holds an appropriate and valid driving licence and there is appropriate third party insurance in place to cover any person injured as a consequence of the participant’s driving; and b. a participant must not be driven by any individual who is not involved in or assisting in organising the Award for the purposes of participating in the Award unless the individual holds an appropriate and valid driving licence and there is appropriate third party insurance in place to cover any person injured as a consequence of the individual’s driving."
              />
            </p>
            <p>
              <FormattedMessage
                id="parentalConsent.i_understand_that_participants_are_required_to_comply"
                defaultMessage="12. I understand that participants are required to comply with the Award requirements contained in the Record Book or ORB, the policies and standards of behaviour of the relevant Award Operator (as amended from time to time) and requirements of the Award Unit in relation to emergency plans, assessment of activities and the conduct of Adventurous Journeys related to the Award, and understand that the Award Unit may withdraw its approval to the participant’s participation in the Award if they do not comply."
              />
            </p>
            <p>
              <FormattedMessage
                id="parentalConsent.i_consent_to_the_provision_of_any"
                defaultMessage="13. I consent to the provision of any personal information that I have provided (including participant data) to the Award Unit and Award Operator. I consent to this information being treated in accordance with the provisions of the privacy policy of the relevant Award Operator (as amended from time to time), the National Privacy Principles contained in the Data Protection Act (UK) 1998 (or any locally equivalent policy or act), and any other privacy legislation, standards, guidelines or instructions binding on them under privacy legislation."
              />
            </p>
            <p>
              <FormattedMessage
                id="parentalConsent.the_award_operators_are_committed_to_respecting"
                defaultMessage="14. The Award Operators are committed to respecting your privacy. Personal information is collected on this form for the purpose of participating in the Award. Participants who do not provide this information to us cannot participate in the Award (note that this does not apply to non-provision of participant data). We may also use your personal information to send you information about other Award activities or events which we believe may be of interest to you. We may disclose this information to other local or international organisations and service providers who assist us in the operation and administration of the Award. If you would like to contact us or access your personal information please write to the Award Operator. You may also contact the Award Operator to request a copy of their privacy policy."
              />
            </p>
          </ReadAllArea>
          </div>}

          {isParentalConsentRequirementsEnabled && <div>
            <h2 className="omega">
              <FormattedHTMLMessage
                id="parentalConsent.custom_requirements_title"
                defaultMessage= {parentalConsentRequirementsTitle}
              />
            </h2>
            <ReadAllArea>
              <p>
                <FormattedHTMLMessage
                  id="parentalConsent.custom_requirements"
                  defaultMessage=  {parentalConsentRequirements}
                />
              </p>
            </ReadAllArea>

            <Checkbox
              label={intl.formatMessage({
                id: 'parentalConsent.custom_requirements',
                defaultMessage: 'I have read, understood, and agree to the requirements and conditions of participation in the Award, as described above and on the website of the Award Operator.'
              })}
              name="customParentalConsent"
            />
          </div>}

          {isParentalConsentRequirementsEnabled2 && <div>
            <h2 className="omega">
              <FormattedHTMLMessage
                id="parentalConsent.custom_requirements_title2"
                defaultMessage= {parentalConsentRequirementsTitle2}
              />
            </h2>
            <ReadAllArea>
              <p>
                <FormattedHTMLMessage
                  id="parentalConsent.custom_requirements2"
                  defaultMessage=  {parentalConsentRequirements2}
                />
              </p>
            </ReadAllArea>

            <Checkbox
              label={intl.formatMessage({
                id: 'parentalConsent.custom_requirements2',
                defaultMessage: 'I have read, understood, and agree to the requirements and conditions of participation in the Award, as described above and on the website of the Award Operator.'
              })}
              name="customParentalConsent2"
            />
          </div>}

          <ConfigurationFile
            configKey={CONFIGURATION_KEYS.parentalConsent.id}
            isPublic
            formattedName={
              <FormattedHTMLMessage
                id="label.parent_agreement"
                defaultMessage="Parental consent"
              />
            }
            organizationId={data.organizationId}
          />

          <h2 className="omega">
            <FormattedMessage
              id="moduleTitle.your_parental_consent"
              defaultMessage="Your parental consent"
            />
          </h2>

          {data.firstName &&
          <div className="row">
            {!customParentalConsentReqEnabled && <div className="col-xs-12 col-md-9 col-md-offset-0">
              <Checkbox
                label={intl.formatMessage(
                  {
                    id: 'parentalConsent.checkbox_copy',
                    defaultMessage: `I’m parent/guardian of ${get(data, 'firstName')} ${get(data, 'lastName')}. I give my consent for him/her to participate in the Award in ${get(data, 'organizationName')} under supervision of a trained Award Leader. I have read, understood and agree with the requirements and conditions of participation in the Award, as described above and on the website of the Award Operator.`
                  },
                  {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    organisationName: data.organizationName
                  }
                )}
                name="accepted"
              />
            </div>}
            <div className="col-xs-12 col-md-9 col-md-offset-0">
              <Checkbox
                label={intl.formatMessage({
                  id: 'parentalConsent.images_consent',
                  defaultMessage: 'As the parent/guardian, I give consent for any images to be used by the Foundation for promotional purposes.'
                })}
                name="imagesConsent"
              />
            </div>
            <div className="col-xs-12 col-md-9 col-md-offset-0">
              {parentalConsentSurveyUrl &&
              <Checkbox
                label={`I consent to my child, ${get(data, 'firstName')} ${get(data, 'lastName')}, to be given the opportunity to participate in the surveys the Award conducts to understand the award experience of participants, measure the outcomes and impact of the Award and other research activity that is in line with the Award's strategy and aims. For more information about the current research activity, please click <a href="${parentalConsentSurveyUrl}">here</a>`}
                intlKey='label.participant_survey_parent'
                intlValues={{
                  firstName: data.firstName,
                  lastName: data.lastName,
                  url: parentalConsentSurveyUrl
                }}
                name="surveyConsent"
                html
              />}
            </div>
          </div>}
          {!data.firstName &&
          <div className="base-margin">
            <FormattedMessage
              id="global.loading"
              defaultMessage="Loading"
            />
          </div>}

          <div className="base-margin--bottom">
            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <Button
                  isLoading={loading}
                  disabled={!isAccepted}
                  fluid
                  intlKey={
                    get(data, 'awardPayment.originPaymentType.value') ===
                    PAYMENTS.ONLINE_MASTERCARD.id
                      ? 'button.continue_to_payment_gateway'
                      : 'button.send'
                  }
                >
                  Send
                </Button>
              </div>
            </div>
          </div>
        </div>}
      </Form>
    )
  }
}

export default enhance(ParentalContestForm)
